/**
 * @param {String} x
 * @return {String[]}
 */
const split = x => String.prototype.split.call(x, "");

export { split };
